module.exports = __webpack_public_path__ + "img/category_tuolit.41e64218.webp";